import React, { useEffect, useState, useRef } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import addIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { Table } from "antd";
import { MODULE_API } from "../../../../../apis";
import "./styles/legaldocument.css";
import axios from "axios";
import swal from "sweetalert";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export default function LegalDocuments() {
  const [subModulefields, setSubModuleFields] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [moduleName, setModuleName] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [formData, setFormData] = useState({});
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [tableData, setTableData] = useState({
    livingWillData: [],
    trustData: [],
    estatePlanningData: [],
    guardianData: [],
    healthcarePowerOfAttorneyData: [],
    powerOfAttorneyData: [],
  });
  const fileRefs = {
    form1: useRef(null),
    form2: useRef(null),
    form3: useRef(null),
    form4: useRef(null),
  };
  console.log("tableDtaa", tableData);
  const showModal = async (name) => {
    setLoading(true);
    setModalTitle(name);
    setModuleName(name);
    setIsModalVisible(true);
    setSubModuleFields(null);
    await getSubModuleAttributes(name);
  };
  const viewModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    setSubModuleFields(null);
    await getSubModuleAttributes(record.module);
  };
  const updateModal = async (record) => {
    setLoading(true);
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("Update");
    setSubModuleFields(null);
    await getSubModuleAttributes(record.module);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const resetAllInputs = () => {
    Object.values(fileRefs).forEach((ref) => {
      if (ref.current) {
        ref.current.value = null;
      }
    });
  };
  const handelCloseModal = () => {
    setIsModalVisible(false);
  };

  const getSubModuleAttributes = async (submod) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(submod);
      if (res && res.attributes) {
        setSubModuleFields(res);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const handleCreate = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };

  const deleteRecord = async (record) => {
    try {
      console.log("record", record);
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const moduleNames = [
    "Living Will",
    "Trust",
    "Healthcare Power of Attorney",
    "Estate Planning",
    "Guardian",
    "Power of Attorney",
  ];

  const fetchData = async (moduleName) => {
    try {
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (event) => {
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      let objToSubmit = {
        "Document Upload": res,
        "Uploaded File Name": name,
      };
      handleSubmit(objToSubmit);
    }
    resetAllInputs();
  };
  const handleSubmit = async (body) => {
    console.log("Submit...", body);
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [body],
      });
      console.log("resposnse Upload", response);
      if (response && response.message) {
        swal("Success!", response.message, "success");
      }
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res.records || [],
      }));
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
  };
  console.log("tableData", tableData);
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const beneficiaryColsData = [
    {
      title: "Beneficiary Designation",
      dataIndex: "Beneficiary Designation",
      key: "beneficiaryDesignation",
      render: (text) => text || "N/A",
    },
    {
      title: "Beneficiary Percent",
      dataIndex: "Beneficiary Percent",
      key: "beneficiaryPercent",
      render: (text) => text + "%" || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        // console.log("viewwwwwwwww",record)
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        console.log("viewwwwwwwww", record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const guardianColsdata = [
    {
      title: "Guardian Designation",
      dataIndex: "Guardian Designation",
      key: "guardianDesignation",
      render: (text) => text || "N/A",
    },
    {
      title: "Guardian Percent",
      dataIndex: "Guardian Percent",
      key: "guardianPercent",
      render: (text) => text + "%" || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const uploadDocCols = [
    {
      title: "Link",
      dataIndex: "Document Upload",
      key: "Document Upload",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        window.open(record["Document Upload"]);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  console.log(tableData);
  useEffect(() => {
    fetchAllModulesData();
  }, []);
  return (
    <>
      <div className="legal-documents-container">
        <div className="legal-document-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="legal-document-title">Legal Documents</h2>
          <ToolTipCreator name={"Disability_Legal_Documents"}/>
        </div>
        </div>
        {/* <div className="legal-document-icon-container">
          <img src={helpIcon} alt="help" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <div className="advance-directive-title-container">
        <h2 className="advance-directive-title">Advance Directives</h2>
      </div>
      <div className="living-will-container">
        <div className="living-will-header-container">
          <h3 className="living-will-title">Living Will</h3>
          <div className="living-will-add-button-container">
            <label
              htmlFor="LivingWill"
              onClick={() => {
                setModuleName("Living Will");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={addIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              id="LivingWill"
              ref={fileRefs.form1}
              hidden
              onChange={async (event) => {
                console.log("eventtttttttt", event);
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>
        <div className="living-will-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.livingWillData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="trust-container">
        <div className="living-will-header-container">
          <h3 className="living-will-title">Trust</h3>
          <div className="living-will-add-button-container">
            <label
              htmlFor="Trust"
              onClick={() => {
                setModuleName("Trust");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={addIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              id="Trust"
              ref={fileRefs.form2}
              hidden
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>
        <div className="living-will-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.trustData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>

      <div className="health-power-container">
        <div className="living-will-header-container">
          <h3 className="living-will-title">Healthcare Power of Attorney</h3>
          <div className="living-will-add-button-container">
            <label
              htmlFor="HealthcarePowerofAttorney"
              onClick={() => {
                setModuleName("Healthcare Power of Attorney");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={addIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              id="HealthcarePowerofAttorney"
              ref={fileRefs.form3}
              // ref={(ref) => (inputFileRef.current.HealthcarePowerofAttorney = ref)}
              hidden
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>
        <div className="living-will-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.healthcarePowerOfAttorneyData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="advance-directive-title-container">
        <h2 className="advance-directive-title">Estate Planning</h2>
      </div>

      <div className="trust-container">
        <div className="living-will-header-container">
          <h3 className="living-will-title">Beneficiary</h3>
          <div
            className="living-will-add-button-container"
            onClick={() => showModal("Estate Planning")}
            style={{ cursor: "pointer", pointerEvents: loading && "none" }}
          >
            <img src={addIcon} alt="Add File" width="24px" height="24px" />
          </div>
        </div>
        <div className="living-will-table-container">
          <Table columns={beneficiaryColsData} dataSource={tableData.estatePlanningData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div>
        <CustomModal
          show={isModalVisible}
          fields={subModulefields && subModulefields}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? handleCreate : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      <div className="trust-container">
        <div className="living-will-header-container">
          <h3 className="living-will-title">Guardian</h3>
          <div
            className="living-will-add-button-container"
            onClick={() => showModal("Guardian")}
            style={{ cursor: "pointer", pointerEvents: loading && "none" }}
          >
            <img src={addIcon} alt="Add File" width="24px" height="24px" />
          </div>
        </div>
        <div className="living-will-table-container">
          <Table columns={guardianColsdata} dataSource={tableData.guardianData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="advance-directive-title-container">
        <h2 className="advance-directive-title">Upload Document</h2>
      </div>
      <div className="living-will-container">
        <div className="living-will-header-container">
          <h3 className="living-will-title">Power of Attorney</h3>
          <div className="living-will-add-button-container">
            <label
              htmlFor="PowerofAttorney"
              onClick={() => {
                setModuleName("Power of Attorney");
              }}
              style={{ cursor: "pointer", pointerEvents: loading && "none" }}
            >
              <img src={addIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              id="PowerofAttorney"
              ref={fileRefs.form4}
              // ref={(ref) => (inputFileRef.current.PowerofAttorney = ref)}
              hidden
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>
        <div className="living-will-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.powerOfAttorneyData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </>
  );
}
